// Import Actions
import { SET_SUBSCRIPTIONS } from './SubscriptionActions';
import { SET_IS_FETCHING } from '../App/AppActions';
import { LOGOUT_USER } from '../User/UserActions';

// Initial State
export const initialState = {
    data: [],
    isFetching: false,
};

const SubscriptionReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_SUBSCRIPTIONS: {
            const otherSubscriptions = state.data.filter(subscription => !action.subscriptions.find(subscriptionToSet => subscriptionToSet._id === subscription._id));
            return {
                ...state,
                data: otherSubscriptions.concat(action.subscriptions),
                isFetching: false,
            };
        }

        case SET_IS_FETCHING:
            if(action.dataType === 'subscriptions') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default SubscriptionReducer;
